/**
 * Paylaşılan in-memory çeviri sözlüğü (localStorage YOK).
 *
 * I18nProvider aktif dilin DB çeviri map'ini buraya yansıtır; hook kullanamayan
 * yerler (class bileşenler, modül fonksiyonları — ör. Libs/Language/Translate'in
 * getTranslate'i) buradan SENKRON okur. Dil değişince I18nProvider günceller.
 */
let currentDict = {};
let currentLang = 'tr';
// I18nProvider dili en az bir kez uyguladı mı? (öncesinde currentLang yalnız yer tutucu)
let langReady = false;

export const setDict = (lang, dict) => {
    currentLang = lang || currentLang;
    if (lang) langReady = true;
    currentDict = (dict && typeof dict === 'object') ? dict : {};
};

export const getDict = () => currentDict;

export const getLang = () => currentLang;

export const isLangReady = () => langReady;
